export * from './types/icon-props';
export { default } from './icon';
